module.exports = __webpack_public_path__ + "static/media/grip-vertical.c6efd3ff.svg";